<script>
import adminChangeLv from "@/pages/modal/adminChangeLv.vue";

// 초기세팅
function initialState() {
  return {
    basicInfo: [],
  };
}

export default {
  components: {
    adminChangeLv,
  },
  data() {
    return initialState();
  },
  created() {
  },
  computed: {
  },
  filters: {
  },
  methods: {
    // 초기화
    resetWindow: function() {
      Object.assign(this.$data, initialState());
    },
    // 처음에 시작
    shown() {
      this.resetWindow();
      this.basicInfo =  this.$store.getters.getModal_md; // store 정보 가져오기
    },
    // 사이드바 닫히면 실행되는 부분
    hidden() {
      this.resetWindow();
    },
    hide() {
      this.$bvModal.hide('modal_md')
    },
  },
  middleware: "authentication",
};
</script>

<template>
  <b-modal
    size="md"
    id="modal_md"
    ref="modal_md"
    @shown="shown"
    @hidden="hidden"
    hide-header
    hide-footer
  >
    <template>
      <adminChangeLv v-if="basicInfo.worker=='adminChangeLv'"></adminChangeLv>
      <div v-if="basicInfo.worker==''" class="row">
        <!-- 좌측 영역 -->
        <div class="col-xl-12">
          <div class="card mb-2">
            <div class="card-body">
              <div class="media align-items-center">
                <div class="media-body overflow-hidden">
                  <h5 class=" text-secondary text-bold">
                    <i class="uil-squint h3 text-danger"></i>
                    ...
                  </h5>
                </div>
                <a class="" href="javascript:void(0);" @click="hide">
                  <div class="btn btn-block p-0">
                    <i class="mdi mdi-close display-6 text-gray"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>
